import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";

export default class extends Controller {
  static targets = ["userSelect", "constructionSelect"];
  static values = { url: String };

  connect() {
    this.initUserSelect();
    this.initConstructionSelect();

    if (this.userSelectTarget.value) {
      this.loadConstructions(this.userSelectTarget.value);
    }
  }

  disconnect() {
    if (this.userSlimSelect) {
      this.userSlimSelect.destroy();
      this.userSlimSelect = null;
    }

    if (this.constructionSlimSelect) {
      this.constructionSlimSelect.destroy();
      this.constructionSlimSelect = null;
    }
  }

  initUserSelect() {
    this.userSlimSelect = new SlimSelect({
      select: this.userSelectTarget,
      settings: {
        placeholderText: "Escolha...",
        searchText: "Nenhum resultado...",
        searchPlaceholder: "Pesquise...",
        allowDeselect: true,
      },
      events: {
        afterChange: (users) => {
          const user = Array.isArray(users) ? users[0] : null;
          const userId = user?.value || "";

          this.resetConstructionSelect();
          if (userId) this.loadConstructions(userId);
        },
      },
    });
  }

  initConstructionSelect() {
    this.constructionSlimSelect = new SlimSelect({
      select: this.constructionSelectTarget,
      settings: {
        placeholderText: "Escolha...",
        searchText: "Nenhum resultado...",
        searchPlaceholder: "Pesquise...",
        allowDeselect: true,
      },
    });
  }

  userChanged() {
    const userId = this.userSelectTarget.value;
    this.resetConstructionSelect();

    if (!userId) return;

    this.loadConstructions(userId);
  }

  async loadConstructions(userId) {
    const url = new URL(this.urlValue, document.baseURI);
    url.searchParams.append("user_id", userId);

    this.constructionSelectTarget.disabled = true;

    try {
      const response = await fetch(url);
      const data = await response.json();

      this.populateConstructionOptions(data);
      this.constructionSelectTarget.disabled = false;
    } catch (_error) {
      this.resetConstructionSelect();
    }
  }

  populateConstructionOptions(options) {
    const selectedConstructionId =
      this.constructionSelectTarget.dataset.selectedConstructionId;

    const data = [
      { text: "Selecione", value: "" },
      ...options.map((option) => ({
        text: option.text,
        value: String(option.value),
        selected:
          selectedConstructionId &&
          String(selectedConstructionId) === String(option.value),
      })),
    ];

    this.constructionSlimSelect.setData(data);

    if (selectedConstructionId) {
      this.constructionSlimSelect.setSelected(String(selectedConstructionId));
    }
  }

  resetConstructionSelect() {
    this.constructionSlimSelect.setData([{ text: "Selecione", value: "" }]);
    this.constructionSlimSelect.setSelected("");
    this.constructionSelectTarget.disabled = true;
  }
}
